import { SimpleTable } from "@/core/components/simple-table";
import { EmptyTableMessage } from "@volca/ui/components/ui/empty-table-message";
import { IInternalTransaction } from "@/internal-transactions/InternalTransactions";
import { AmountCol } from "./cols/amount-col";
import { DateInitiatedCol } from "./cols/date-initiated-col";
import { StatusCol } from "./cols/status-col";
import { TypeCol } from "./cols/type-col";

interface InternalTransactionsTableProps {
  data: IInternalTransaction[];
}

const columns = [AmountCol(), DateInitiatedCol(), TypeCol(), StatusCol()];

export const InternalTransactionsTable = ({
  data,
}: InternalTransactionsTableProps) => {
  if (data.length === 0) {
    return <EmptyTableMessage>No transactions yet.</EmptyTableMessage>;
  }

  return (
    <SimpleTable
      columns={columns}
      data={data}
      className="w-full min-w-[600px]"
    />
  );
};
